<emr-modal headerTitle="Show Distance" i18n-headerTitle="@@show_distance" [bsModalRef]=bsShowDistanceModalRef>
    <div modal-body class="col-md-12 bg-show-distance">
      <app-show-distance [distanceToTargetsRequest]="distanceToTargetsRequest"  (CancelClick)="onPopupCancel()"></app-show-distance>
    </div>
  </emr-modal>